import React, { useContext } from "react";
import { General } from "../tools/styles";
import { WatchContext } from '../WatchContext'

const WaterSummary = () => {
  let { water } = useContext(WatchContext);

  return (
    <div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
        <General.SmallHead>{water?.title}</General.SmallHead>
        <span>
        {water?.currentValue ? `${water?.salinityStatus?.consid} based on the entered salinity of ${water?.currentValue} ppt.` : "need more information"}
        </span>
        
        </div>
  );
};

export default WaterSummary;
